export const common = {
	//Menu
	"menu.play": "Cheza",
	"menu.ranking": "Orodha",
	"menu.prizes": "Tuzo",
	"menu.rules": "Sheria",
	"menu.leagues": "Ligi",
	"menu.betwayAccount": "Akaunti ya Betway",
	"menu.terms": "Masharti",

	//Play
	"play.heroTitle": "Tabiri matokeo ya kila mchezo na ushinde tuzo!",
	"play.heroSubtitle": "Timu gani itashinda? Magoli mangapi watafunga? Tabiri sasa na ushindane na marafiki zako!",
	"play.playNow": "Cheza sasa",
	"play.seePrizes": "Ona tuzo",
	"play.statistics": "Takwimu",
	"play.lastMatches": "Michezo 5 ya mwisho ya kila timu",
	"play.stats": "Takwimu",

	//Ranking
	"ranking.season": "Msimu",
	"ranking.weekly": "Kila wiki",
	"ranking.selectType": "Chagua aina ya orodha",
	"ranking.selectWeek": "Chagua wiki",
	"ranking.myPosition": "Nafasi yangu",
	"ranking.points": "Pointi",
	"ranking.rank": "Nafasi",
	"ranking.topMembers": "Wachezaji 20 bora",
	"ranking.noRanking": "Hakuna orodha bado.",
	"ranking.competitionStart": "Mara tu mashindano yatakapoanza, watumiaji wote waliocheza Score Predict wataorodheshwa hapa.",
	"ranking.loadMore": "Pakia Zaidi",
	"ranking.loading": "Inapakia...",

	//Leagues
	"leagues.heroTitle": "Shindana na marafiki zako au jiunge na ligi za umma!",
	"leagues.heroSubtitle": "Nani ana ujuzi bora wa kutabiri? Unda au jiunge na ligi ili ujue!",
	"leagues.createLeague": "Unda ligi",
	"leagues.joinLeague": "Jiunge na ligi",
	"leagues.createLeagueButton": "Unda ligi",
	"leagues.joinLeagueButton": "Jiunge na ligi",
	"leagues.enterName": "Ingiza jina la ligi",
	"leagues.enterCode": "Ingiza msimbo wa mwaliko",
	"leagues.myLeagues": "Ligi zangu",
	"leagues.member": "mwanachama",
	"leagues.members": "wanachama",
	"leagues.membersCapital": "Wanachama",
	"leagues.league": "Ligi",
	"leagues.shareCodeText": "Marafiki zako wanaweza kujiunge na ligi yako kwa kutumia msimbo huu:",
	"leagues.shareCode": "Shiriki msimbo",
	"leagues.editLeague": "Hariri ligi",
	"leagues.delete": "Futa",
	"leagues.leave": "Ondoka",
	"leagues.deleteWarning": "Historia yote na wanachama watafutwa kabisa.",
	"leagues.leaveWarning": "Pointi zako za kutabiri na nafasi yako itafutwa.",
	"leagues.confirmDelete": "Ndiyo, futa",
	"leagues.confirmLeave": "Ndiyo, ondoka",
	"leagues.cancel": "Ghairi",
	"leagues.ban": "Zuia",
	"leagues.edit": "Hariri",
	"leagues.save": "Hifadhi",

	//Errors
	"errors.savingPredictions": "Hitilafu katika kuhifadhi utabiri",

	//Predictions
	"predictions.successModal.title": "Utabiri umethibitishwa!",
	"predictions.successModal.subtitle": "Utabiri wako umehifadhiwa kwa mafanikio!",
	"predictions.successModal.close": "Funga",
	"predictions.seasonEnd.title": "Msimu umekamilika!",
	"predictions.seasonEnd.message":
		"Huo ndio mwisho wa msimu huu wa BW ScorePredict — kazi nzuri! Hongera kwa mshindi mkuu wa tuzo, [username], aliyeshinda safari ya watu wawili kuona Arsenal moja kwa moja katika Emirates Stadium. Wakati vitendo vimepumzika kidogo, tayari tunajiandaa kwa raundi ijayo. Endelea kufuatilia masasisho na jiandae kurudi na utabiri wa kina zaidi.",
	"predictions.seasonEnd.subtitle": "Hatusubiri kuwa nawe tena katika mchezo!",
	"predictions.seasonEnd.myPosition": "Nafasi yangu",
	"predictions.seasonEnd.points": "Pointi",
	"predictions.seasonEnd.rank": "Nafasi",
	"predictions.seasonEnd.topMembers": "Wachezaji 10 bora",
	"predictions.countdown.deadline": "Muda wa mwisho",
	"predictions.countdown.deadlineMissed": "Muda wa mwisho umepita",
	"predictions.countdown.matchweekDeadline": "Muda wa mwisho wa wiki ya mechi",
	"predictions.countdown.deadlineMissedMessage":
		"Hukufanya utabiri wako kwa wiki hii, kwa hivyo hakuna pointi zilizopata - lakini kuna wiki ijayo ya kurudi!",
	"predictions.countdown.days": "SIKU",
	"predictions.countdown.hours": "MASAA",
	"predictions.countdown.minutes": "DAK.",
	"predictions.countdown.seconds": "SEK.",
	"predictions.bonusFooter.loadingOdds": "Inapakia uwezekano...",
	"predictions.bonusFooter.draw": "Sare",
	"predictions.bonusFooter.unknown": "Haijulikani",
	"predictions.bonusFooter.oddsToWin": "Uwezekano wa kushinda",
	"predictions.roundSelector.previousRound": "Raundi iliyopita",
	"predictions.roundSelector.nextRound": "Raundi ijayo",
	"predictions.points.totalPoints": "Jumla ya pointi",
	"predictions.points.currentPosition": "Nafasi ya sasa",
	"predictions.points.points": "Pointi",
	"predictions.points.totalPointsLabel": "Jumla ya pointi",
	"predictions.submitButton.submitting": "Inatuma...",
	"predictions.submitButton.predictionsSaved": "Utabiri umehifadhiwa",
	"predictions.submitButton.updatePredictions": "Sasisha utabiri",
	"predictions.submitButton.submitAllPredictions": "Tuma utabiri wote",
	"predictions.predictionCard.result": "Matokeo",
	"predictions.predictionCard.pts": "Pointi",

	//Predictions Info Card
	"predictions.infoCard.title": "Tabiri matokeo ya kila mchezo na ushinde tuzo!",
	"predictions.infoCard.description":
		"Nani atakuwa mshindi? Magoli mangapi watafunga? Tabiri sasa na ushindane na marafiki zako! Kanuni na masharti yanatumika.",
	"predictions.infoCard.playButton": "Cheza sasa",
	"predictions.infoCard.prizesButton": "Ona tuzo",

	//Common Components
	"common.shareCard.title": "Waliko marafiki zako wacheze",
	"common.shareCard.description":
		"Waliko marafiki zako wacheze BW ScorePredict ili muone ni nani kati yenu ni meneja bora wa mpira, na ili nyote mwe na nafasi ya kushinda tuzo za kila wiki!",
	"common.shareCard.button": "Waliko marafiki",
	"common.shareCard.shareTitle": "Pakua BetwayScores",
	"common.shareCard.shareBody": "Pakua BetwayScores na ushindane na marafiki zako katika BW ScorePredict!",

	"common.accessDenied.title": "Pakua programu ya Betway Scores",
	"common.accessDenied.description":
		"Ili kufikia maudhui haya, tafadhali pakua programu ya Betway Scores. Pata matokeo ya hivi karibuni, utabiri na vipengele vya kipekee mkononi mwako.",
	"common.accessDenied.rulesText": "Inapatikana kwa vifaa vya iOS na Android. Pakua sasa ili uanze!",
	"common.accessDenied.button": "Pakua programu ya Betway Scores",

	"common.prizesInfoCard.title": "Maelezo kuhusu tuzo",
	"common.prizesInfoCard.description1":
		"Huhitaji kuwa na akaunti ya Betway ili kucheza BW ScorePredict, hata hivyo ili kupokea tuzo ya kila wiki kwa kuwa katika Top 10 ya wiki, unahitaji kuwa na akaunti ya Betway ili mapato hayo yawekwe.",
	"common.prizesInfoCard.description2": "Ona Sheria na Masharti ya mchezo kwa maelezo ya tuzo za kila wiki na za jumla.",
	"common.prizesInfoCard.button": "Ona sheria",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Tuzo Kuu – Tazama Arsenal katika Emirates Stadium",
	"prizes.prizeCard1.description":
		"Shinda safari ya watu wawili kuona Arsenal wakicheza katika Emirates Stadium huko London, ikijumuisha ndege (ikiwa inahitajika), malazi (ikiwa inahitajika) na £500 za matumizi.",
	"prizes.prizeCard2.title": "Mshindi wa raundi – Tuzo ya fedha katika akaunti yako ya Betway",
	"prizes.prizeCard2.description":
		"Mchezaji bora wa kila wiki atashinda €150 (au sawa na sarafu – ona sehemu ya 'Sheria') kama fedha zilizowekwa katika akaunti yake ya Betway.",
	"prizes.prizeCard3.title": "Nafasi za 2-10 kila raundi – Tuzo ya fedha katika akaunti yako ya Betway",
	"prizes.prizeCard3.description":
		"Wale wanaokamilisha nafasi ya 2 hadi ya 10 kila wiki pia watapokea tuzo za fedha katika akaunti zao za Betway. Ona sehemu ya 'Sheria' kwa kiasi halisi unachoweza kushinda.",

	"common.modal.pointsFormat": "+{points}pointi",

	//Betway Account Fragment
	"betwayAccount.title": "Fungua akaunti ya Betway",
	"betwayAccount.description":
		"Huhitaji kuwa na akaunti ya Betway ili kucheza BW ScorePredict, hata hivyo ili kupokea tuzo ya kila wiki kwa kuwa katika Top 10 ya wiki, unahitaji kuwa na akaunti ya Betway ili mapato hayo yawekwe.",
	"betwayAccount.rulesText": "Ona Sheria na Masharti ya mchezo kwa maelezo ya tuzo za kila wiki na za jumla.",
	"betwayAccount.button": "Fungua akaunti ya Betway",
};
